import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ErrCode, FileItem, LinkPathListApiInput } from '../../shared/models';
import { LinkFileListService } from '../../link-consume/services/link-file-list.service';
import { LoggerService } from '../../core/logger.service';
import { FileItemService } from '../file-item.service';
import { SyncCookieService } from '../../core/sync-cookie.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BuildTransferItemService } from 'src/app/transfer/services/build-transfer-item.service';
import { IFile } from 'src/sync';
import { AppBarActionsService } from 'src/app/shared/layout/root-layout/app-bar-actions.service';
import { FileViewService } from '../file-view.service';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { RootLayoutConfigService } from 'src/app/shared/layout/root-layout/root-layout-config.service';
import { DatePipe } from '@angular/common';
import { Action } from "@material-library"
import { Title } from '@angular/platform-browser';
import { ApiService } from 'src/app/core/api.service';

@Component({
    selector: 'app-preview-link',
    templateUrl: './preview-link.component.html',
    styleUrls: ['./preview-link.component.scss']
})
export class PreviewLinkComponent implements OnInit, OnDestroy {
    @Input() public type: string; // binding from component.
    public item: IFile;
    public list: IFile[] = [];
    public locId: number;
    public initialized = false;
    public ctx: string;
    public notice = 0;
    public errcode: ErrCode;
    public upsell = false;
    public isPro = 0;
    public isBusiness = 1; // set default 1 so that it's not shown immediately

    //white label attributes
    public isWhiteLabel: boolean;
    public linkTextColor: string = '';
    public buttonTextColor: string;
    public buttonPrimaryColor: string;
    public url: string;
    public mimeType: string;

    private subscription: Subscription;
    public compat = 0;
    private isSmScreen: boolean;
    private PAGE_TITLE = 'Sync.com';

    constructor(
        private linkPathListService: LinkFileListService,
        private loggerService: LoggerService,
        private fileItemService: FileItemService,
        private syncCookieService: SyncCookieService,
        private route: ActivatedRoute,
        private router: Router,
        private buildTransferItemService: BuildTransferItemService,
        private appBarActionsService: AppBarActionsService,
        private fileViewService: FileViewService,
        public breakpointObserver: BreakpointObserver,
        private rootLayoutConfigService: RootLayoutConfigService,
        private datePipe: DatePipe,
        private pageTitleService: Title,
        private apiService: ApiService,
    ) {}

    ngOnInit() {
        this.locId = this.route.snapshot.params['id'];
        // this.ctx = this.$stateParams.ctx;
        let dispatched = false;

        const rawKey = this.linkPathListService.sanitizeKey(
            this.route.snapshot.params['key']
                ?  this.route.snapshot.params['key']
                : this.route.snapshot.fragment
        );

        if (!this.type) {
            this.type = this.route.snapshot.params['type'];
        }

        const linkPass = this.syncCookieService.getLinkPassword(
            this.route.snapshot.params['cachekey']
        );
        this.initialized = false;

        if (this.type == 'doc' || this.type == 'office' || this.type == 'officefse' || this.type == 'officefsv') {
            // fetch the latest linkpathlisting for the current file
            // the doc/wopi component should have the latest copy of pathitem for preview
            // note: this will only fetch the pathlisting for a single file, not the entire parent folder
            dispatched = true;
            const input = new LinkPathListApiInput();
            input.sync_id = this.route.snapshot.params['id']; // fetch pathlist for current file only
            input.publink_id = this.route.snapshot.params['cachekey'];
            input.key = rawKey;
            input.passwordlock = linkPass;
            this.linkPathListService.dispatch(input);
        }

        this.subscription = this.linkPathListService
            .getSubscription()
            .subscribe(async (data) => {
                try {
                    if (data.error) {
                        if (data.error instanceof ErrCode) {
                            const { params, queryParams, fragment } = this.route.snapshot;
                            const errorCode = data.error.code;

                            // route to link-consume component, i.e., parent of preview-link
                            const navigationParams = ['/dl', params['cachekey']];
                            if (params['key']) { navigationParams.splice(2, 0, params['key']); }

                            let warningMessage = '';

                            switch (errorCode) {
                                case 8018:
                                    warningMessage = 'Password is missing or expired';
                                    break;
                                case 8026:
                                    warningMessage = 'File has been deleted';
                                    break;
                                case 400:
                                    warningMessage = 'Link has been removed';
                                    break;
                                case 8025:
                                    warningMessage = 'This link has been suspended';
                                    break;
                                case 8031:
                                    warningMessage = 'Link has reached daily download limit. Contact link owner or upgrade account to get unlimited downloads.';
                                    break;
                                default:
                                    this.loggerService.e('An error was received loading link preview', data.error);
                                    throw new ErrCode(errorCode, data.error.msg);
                            }

                            if (warningMessage) {
                                this.loggerService.warn(warningMessage);
                                this.router.navigate(navigationParams, {
                                    ...this.linkPathListService.decorateQueryParams(queryParams),
                                    ...this.linkPathListService.decorateFragment(true, fragment)
                                });
                            }
                        }

                    }
                    if (
                        data &&
                        data.pathlist &&
                        data.pathlist.length &&
                        data.loaded &&
                        data.sorted
                    ) {
                        this.compat = data.compat;
                        if (!this.compat &&
                            (this.type == 'video' ||
                                this.type == 'doc' ||
                                this.type == 'pdf' ||
                                this.type == 'office' ||
                                this.type == 'officefse' ||
                                this.type == 'officefsv'
                            )
                        ) {
                            this.type = 'default';
                        }

                        this.list = data.pathlist.filter((val) => {
                            return this.fileItemService.isImage(val);
                        });

                        const item = data.pathlist.filter((value) => {
                            if (value.sync_id == this.route.snapshot.params['id']) {
                                return true;
                            }
                        });
                        if (item.length == 0) {
                            throw new ErrCode(1804);
                        } else if (item.length == 1) {
                            this.item = item[0];
                            this.pageTitleService.setTitle(
                                `${this.item.name} | ${this.PAGE_TITLE}`
                            );
                            const timestamp = this.item.usertime ? this.datePipe.transform(this.item.usertime, 'MMM d, y h:mm a') : '';
                            const linkSubTitle = `Modified on ${timestamp}`;
                            this.rootLayoutConfigService.updateConfig({
                                linkTitle: this.item.name,
                                linkSubTitle,
                                appBar: {
                                    showBackButton: !data?.is_root || (data?.cwd && data?.cwd?.type === 'dir')
                                }
                            });
                        } else {
                            throw new ErrCode(
                                1000,
                                'This file listing has an error'
                            );
                        }

                        if (this.compat) {
                            const streamItem =
                                await this.buildTransferItemService.getStreamingDetails(this.item);

                            if (streamItem.url && streamItem.mimeType) {
                                if (streamItem.mimeType.startsWith('video/')) {
                                    this.type = 'video';
                                } else if (streamItem.mimeType.startsWith('audio/')) {
                                    this.type = 'audio';
                                } else {
                                    this.type = 'default';
                                }
                                this.url = streamItem.url;
                                this.mimeType = streamItem.mimeType;
                            }
                        }

                        if (
                            (this.type != 'default' && this.type != 'office' && this.type != 'officefse' && this.type != 'officefsv') &&
                            !this.fileItemService.isPreviewable(this.item) &&
                            !this.mimeType
                        ) {
                            this.type = 'default';
                            this.notice = 1;
                        }
                        this.isPro = data.is_pro;
                        this.isBusiness = data.is_business;
                        this.initialized = true;
                        this.initActions();
                    } else if (!dispatched) {
                        dispatched = true;
                        const input = new LinkPathListApiInput();
                        input.sync_id = this.route.snapshot.queryParams['sync_id'];
                        input.publink_id = this.route.snapshot.params['cachekey'];
                        input.key = rawKey;
                        input.passwordlock = linkPass;
                        this.linkPathListService.dispatch(input);
                        this.loggerService.info('Dispatched');
                    }
                    //get white label attributes
                    if (data.loaded && data.sorted) {
                        if (data.image_cachekey) {
                            this.isWhiteLabel = true;
                            this.linkTextColor = data.link_text_color;
                            this.buttonPrimaryColor = data.button_primary_color;
                            this.buttonTextColor = data.button_text_color;
                        }
                    }
                } catch (ex) {
                    this.loggerService.e('Cannot process link', ex);
                    this.type = 'error';
                    this.errcode = ErrCode.fromException(ex);
                    this.initialized = true;
                }
            });

        this.breakpointObserver
        .observe([`(max-width: 599px)`])
        .subscribe((state: BreakpointState) => {
          if (state.matches) {
            // Condition for sm/xs screens
            this.isSmScreen = true
          } else {
            this.isSmScreen = false
          }
          this.initActions();
        });
    }

    public onStateChange(event: any) {
        this.type = event.type;
        this.upsell = event.upsell;
    }

    public showReportDialog() {
        // const ref = this.modalService.open(DialogReportLinkComponent, {
        //     backdropClass: 'in',
        //     windowClass: 'in',
        //     backdrop: 'static',
        // });
        // ref.componentInstance.linkID = this.route.snapshot.params['cachekey'];
    }

    public initActions() {
        let allActions: Array<Action> = [];
        if (this.item) {
            if (this.fileViewService.isOpenable(this.item) && this.item.type == 'file') {
                allActions.push({
                    name: 'Open',
                    icon: 'open-in-new',
                    type: 'primary',
                    onClick: () => {
                        this.fileViewService.openFile(this.item);
                    },
                })
            }
            if (this.fileViewService.showDownload(this.item)) {
                allActions.push({
                    name: 'Download',
                    icon: 'download',
                    type: 'primary',
                    onClick: () => {
                      this.fileViewService.downloadCompat(this.item);
                      this.linkConsume(this.item)
                    }
                });
            }
            if (this.fileViewService.showOfficeEdit(this.item) && this.isSmScreen) {
                allActions.push({
                    name: 'View in Offce',
                    icon: 'preview',
                    type: 'primary',
                    onClick: () => {
                      this.fileViewService.openOfficeView(this.item);
                    },
                })
            }
            if (this.fileViewService.showOfficeEdit(this.item) && !this.isSmScreen) {
                allActions.push({
                    name: 'Edit in Office',
                    icon: 'edit',
                    type: 'primary',
                    onClick: () => {
                      this.fileViewService.openOfficeEdit(this.item, this.route)
                    },
                  })
            }
        }
        this.appBarActionsService.updateActions({
            actions: allActions,
            limit: 5,
            rowData: this.item
        })
    }

    public linkConsume(data: IFile){
        if(data.linkID){
            this.apiService.execute('linkconsume', {
                links: [{ publink_id: data.linkID }],
            });
        }
    }
    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    public getCurrentFile(file: FileItem) {
        this.item = file;
        const timestamp = this.item.usertime ? this.datePipe.transform(this.item.usertime, 'MMM d, y h:mm a') : '';
        const linkSubTitle = `Modified on ${timestamp}`;
        this.rootLayoutConfigService.updateConfig({
            linkTitle: this.item.name,
            linkSubTitle,
            appBar: {
                showBackButton: (this.item?.pid != 0) 
            }
        });
    }
}
